import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { removeRouterOutletsFromUrl } from '@vendasta/shared';
import { BehaviorSubject, filter, takeUntil } from 'rxjs';

declare const window: any;

@Component({
  template: `
    <mat-progress-bar
      class="step"
      [class.show]="loading"
      mode="determinate"
      [value]="loadingPercent"
      color="primary"
    ></mat-progress-bar>
    <iframe
      class="step"
      [class.show]="!loading"
      #content
      width="100%"
      frameBorder="0"
      style="min-width: 1000px; margin-top: -5px; height: 100%;"
    ></iframe>
  `,
  styles: [
    `
      .show {
        opacity: 1 !important;
      }
      .step {
        opacity: 0;
        -webkit-transition: opacity 1s ease-in;
        transition: 0.1s ease-in all;
      }
    `,
  ],
})
export class EmbedComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('content', { static: true }) content: ElementRef;
  private triggeredRoute = false;
  private embedTriggered = false;

  loading = true;
  loadingPercent = 0;
  private routerSubscription;
  destroyed$$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor(
    private router: Router,
    private ref: ChangeDetectorRef,
    private _zone: NgZone,
  ) {}

  ngOnInit(): void {
    // NavigationEnd event emits before this component initialized.
    this.navigationEndEventCallback();
  }

  updateRoute(path: string): void {
    if (this.triggeredRoute === false) {
      this.embedTriggered = true;
      const angularRoute = this.router.config.find((route) => `/${route.path}/` === path.split('?')[0]);
      if (angularRoute) {
        path = angularRoute.path;
      }
      this.router.navigateByUrl(path);
    } else {
      this.triggeredRoute = false;
      this.finishLoading();
      this.ref.detectChanges(); // This is required in safari and ie - maybe bug with current
      // angular version
    }
  }

  finishLoading(): void {
    this.loadingPercent = 100;
    this.loading = false;
    window.setTimeout(() => (this.loadingPercent = 0), 200);
  }

  startLoading(): void {
    this.loading = true;
    window.setTimeout(() => (this.loadingPercent = 20), 80);
    window.setTimeout(() => (this.loadingPercent = 90), 200);
  }

  navigationEndEventCallback(): void {
    if (this.embedTriggered === false) {
      this.triggeredRoute = true;
      this.startLoading();
      // setTimeout is needed, otherwise it fires too quickly to actually target the iframe
      // Setting contentWindow.location is required for Firefox, ie - setting src doesnt work for these
      window.setTimeout(
        () => (this.content.nativeElement.contentWindow.location = removeRouterOutletsFromUrl(this.router.url)),
        0,
      );
    } else {
      this.embedTriggered = false;
    }
  }

  ngAfterViewInit(): void {
    this.routerSubscription = this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.destroyed$$),
      )
      .subscribe(() => {
        this.navigationEndEventCallback();
      });

    this.content.nativeElement.onload = (): void => {
      const path = window.location.pathname + window.location.search;
      if (path === '/login/') {
        window.location.href = path;
        return;
      }
      window.addEventListener('click', this.clickNotifier.bind(self));
      window.addEventListener('keypress', this.keyNotifier.bind(self));
      this.updateRoute(path);
    };
  }

  ngOnDestroy(): void {
    this.destroyed$$.next(true);
    this.destroyed$$.complete();
  }

  clickNotifier(): void {
    this._zone.run(window.parent.ngAppComponent.iframeClickHandler);
  }

  keyNotifier(e: any): void {
    this._zone.run(window.parent.ngAppComponent.revealOmnisearch.bind(this, e));
  }
}
